export default [
    {
        path: '/android',
        name: 'AndroidApks',
        component: () => import ('./AndroidApks'),
    }
];